import React from "react";
import PromineoModalForGrid from "components/common/controls/modal/PromineoModalForGrid";

interface Props {
  children: React.ReactChild;
  onClose: () => void;
}

export default function ProductLicenseModal(props: Props) {
  const { children, onClose } = props;
  return (
    <PromineoModalForGrid
      visible={true}
      onClose={onClose}
      width="auto"
      height="auto"
      displayDefaultActions={false}
    >
      {children}
    </PromineoModalForGrid>
  );
}
